// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"906":"6cadeffc","928":"5322d2c5"}[chunkId] + ".css";
};